import { IndexPage } from './IndexPage';
import { DetailPage } from './DetailPage';
import { OperationChannelsPage } from './OperationDetailPage';
import { OperationBonusesPage } from './OperationDetailPage';
import { ChannelDetailPage } from './ChannelDetailPage';
import { GameConfigurationDetailPage } from './GameConfigurationDetailPage';
import { AddCurrencyPage } from './AddCurrencyPage';
import { AddChannelPage } from './AddChannelPage';
import { CurrencyDetailPage } from './CurrencyDetailPage';
import { AddBonusPage } from './AddBonusPage';
import { CreatePage } from './CreatePage';
import { AvailableProgressiveBonusPage } from './AvailableProgressiveBonusPage';

export {
IndexPage,
DetailPage,
OperationChannelsPage,
OperationBonusesPage,
ChannelDetailPage,
GameConfigurationDetailPage,
AddCurrencyPage,
CurrencyDetailPage,
AddChannelPage,
AddBonusPage,
CreatePage,
AvailableProgressiveBonusPage,
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Customers/index.ts
 **/